<template>
  <div class="callLogs">
    <el-row>
      <el-col :span="24">{{ companyName }}</el-col>
    </el-row>
    <!-- @tab-click="choosePhone" -->
    <el-tabs type="border-card" class="mt-10" @tab-click="chooseTabEvent">
      <el-tab-pane label="客户手机">
        <div v-if="hasPhone(phoneFromData)">
        <el-row v-for="(phone, index) in phoneFromData"
            :key="index">
          <el-col
            :span="18"
            class="mt-10"
          >
            <!-- <span class="callNum" @click="call(phone.custom_phone)" -->
              <!-- phone.custom_phone -->
            <span class="callNum" 
              ><phonecom-list :comPhone="phone.custom_phone" :vagaryPhone="phone.vagary_phone" :copyAble="false" v-show="phone.custom_phone" style="display: inline-block" />
              <i
                class="el-icon-phone-outline"
                style="color: rgb(87, 135, 255)"
                @click="call(phone.vagary_phone ? phone.vagary_phone : phone.custom_phone)"
              ></i
            ></span>
            <span style="font-size: medium" class="ml10">客户所在城市:</span>
            <span style="font-size: medium" >{{ phone.custom_city_name ? phone.custom_city_name : "暂无" }}</span>
            <span style="font-size: medium" class="ml10">手机所属省份:</span>
            <span style="font-size: medium" >{{ phone.phone_province ? phone.phone_province : "暂无" }}</span>
          </el-col>
        </el-row>
      </div>
      <div v-else>
        <el-row>
          <el-col :span="6" class="mt-10" v-for="(phone, index) in callPhone1" :key="index">
            <span class="callNum"><phonecom-list :comPhone="phone" :vagaryPhone="phone" :copyAble="false" v-show="phone.custom_phone" style="display: inline-block"/> <i @click="call(phone)" class="el-icon-phone-outline" style="color: rgb(87, 135, 255)"></i></span>
          </el-col>
        </el-row>
      </div>
        <el-table
          :data="pageData1"
          size="mini"
          border
          style="width: 100%; margin-top: 0.2rem"
        >
          <el-table-column label="主叫人">
            <template slot-scope="scope">
              {{ scope.row.user ? scope.row.user.username : "测试" }}
            </template>
          </el-table-column>
          <el-table-column label="主叫号码">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.caller" placement="top">
                <span class="hide-style">{{ scope.row.caller }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="被叫号码">
            <template slot-scope="scope">
                <!-- <span class="hide-style">{{ scope.row.callee ? scope.row.callee.replace(scope.row.callee.substring(2,7),'*****') : scope.row.callee}}</span> -->
                <phonecom-list :comPhone="scope.row.callee" :vagaryPhone="scope.row.vagary_phone" :copyAble="false" :showAble="false" v-show="scope.row.callee"/>
            </template>
          </el-table-column>
          <el-table-column label="通话状态">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.ul_fail_reason"
                :content="scope.row.ul_fail_reason"
                placement="top"
              >
                <span class="hide-style">{{ scope.row.ul_fail_reason }}</span>
              </el-tooltip>
              <span v-else>待处理</span>
            </template>
          </el-table-column>
          <el-table-column label="时长(秒)">
            <template slot-scope="scope">
              <span>{{ scope.row.billsec }}</span>
              <i
                v-if="scope.row.record_flag === 1"
                style="color: #5cb6ff; font-size: 0.4rem; cursor: pointer"
                class="el-icon-mic"
                @click="
                  play(
                    scope.row.file_storage,
                    scope.row.record_file_download_url
                  )
                "
              ></i>
            </template>
          </el-table-column>
          <el-table-column label="呼叫时间">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.fwd_start_time" placement="top">
                <span class="hide-style">{{ scope.row.fwd_start_time }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          class="mt-10 text-r"
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false"
          :current-page="pageOption1.currentPage"
          :page-size="pageOption1.pageSize"
          :total="pageOption1.total"
          @current-change="handleCurrentChange1"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="客户短信">
        <!-- <el-link style="color: #409EFF;cursor: pointer" :underline="false" @click="openPhoneToSendMsg(scope.row.phone)">{{
        scope.row.phone ? scope.row.phone : "" }}
        </el-link> -->
        <el-button
          @click="openPhoneToSendMsg(callPhone1)"
          type="primary"
          size="mini"
          icon="el-icon-s-comment"
          circle
        >
        </el-button>
        <el-table
          :data="messageRecord"
          size="mini"
          border
          style="width: 100%; margin-top: 0.2rem"
        >
          <el-table-column label="客户手机" width="100">
            <template slot-scope="scope">
              <!-- {{ scope.row.phone ? scope.row.phone : "" }} -->
              <phonecom-list :comPhone="scope.row.phone" :vagaryPhone="scope.row.vagary_phone" :copyAble="false" :showAble="false" v-show="scope.row.phone"/>
            </template>
          </el-table-column>

          <el-table-column label="发送时间" width="110">
            <template slot-scope="scope">
              {{ scope.row.created_at ? scope.row.created_at : "" }}
            </template>
          </el-table-column>
          <el-table-column label="发送内容" width="200">
            <template slot-scope="scope">
                <span>{{ scope.row.content }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发送状态" width="60">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 'SUCCESS'">成功</span>
              <span v-else>失败</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="40">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="再次发送" placement="top">
                <el-button
                  @click="handleSend(scope.row)"
                  type="primary"
                  size="mini"
                  icon="el-icon-bell"
                  circle
                >
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          class="mt-10 text-r"
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false"
          :current-page="pageOption4.currentPage"
          :page-size="pageOption4.pageSize"
          :total="pageOption4.total"
          @current-change="handleCurrentChange4"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="播放"
      :visible.sync="dialogPlayVisible"
      :append-to-body="true"
      :before-close="dialogPlayVisibleBeforeClose"
    >
      <el-row class="playCon">
        <el-card class="card" :body-style="{ padding: '10px' }">
          <div id="waveform" ref="waveform"></div>
        </el-card>
        <div style="padding: 10px" id="wave-timeline" ref="wave-timeline"></div>
      </el-row>
      <div class="text-c">
        <el-button type="primary" @click="playMusic" size="mini">
          <i
            :class="[isPlay ? 'el-icon-video-pause' : 'el-icon-video-play']"
          ></i>
          {{ isPlay ? "暂停" : "播放" }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 自定义短信发送 -->
    <el-dialog title="发送短信" :append-to-body="true" :visible.sync="sendMsgDialog" width="40%" :before-close="handleAddWorkOrderClose">
      <el-form :model="sendMsgForm" ref="sendMsgForm" label-width="80px">
        <el-form-item label="短信内容">
          <el-input type="textarea" v-model="sendMsgForm.msg_content" placeholder="请输入短信内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="submitSendMsgForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import WaveSurfer from 'wavesurfer.js'
import Timeline from 'wavesurfer.js/dist/plugin/wavesurfer.timeline.js'
import PhonecomList from './PhonecomList'
export default {
  name: 'CallLogs',
  props: {
    company: String,
    phone: Array,
    phone1: Array,
    phone2: Array,
    phone3: Array
  },
  components: {PhonecomList},
  data () {
    return {
      phoneFromData: [],
      // phoneFromTab: 'choosePhone',
      customerCity: '',
      phoneProvice: '',
      companyName: '',
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageData1: [],
      pageOption1: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageData2: [],
      pageOption2: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageData3: [],
      pageOption3: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOption4: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      wavesurfer: null,
      dialogPlayVisible: false,
      isPlay: false,
      messageRecord: [],
      sendMsgDialog: false,
      sendToClientPhone: '',
      sendMsgForm: {
        msg_content: ''
      }
    }
  },
  watch: {
    company: function (val) {
      this.pageOption.total = 0
      this.pageOption.currentPage = 1
      this.pageOption1.total = 0
      this.pageOption1.currentPage = 1
      this.pageOption2.total = 0
      this.pageOption2.currentPage = 1
      this.pageOption3.total = 0
      this.pageOption3.currentPage = 1
      this.companyName = val || ''
    },
    phone: function (val) {
      this.callPhone = val || []
      this.pageData = []
      if (val.length > 0) this.getLogs()
    },
    phone1: function (val) {
      this.callPhone1 = val || []
      setTimeout(() => {
        this.getPhoneAddress()
      })
      this.pageData1 = []
      if (val.length > 0) this.getLogs1()
    },
    phone2: function (val) {
      this.callPhone2 = val || []
      this.pageData2 = []
      if (val.length > 0) this.getLogs2()
    },
    phone3: function (val) {
      this.callPhone3 = val || []
      this.pageData3 = []
      if (val.length > 0) this.getLogs3()
    }
  },
  methods: {
    openPhoneToSendMsg (phone) {
      this.sendMsgDialog = true
      this.sendToClientPhone = phone
    },
    submitSendMsgForm () {
      if (!this.sendMsgForm.msg_content) {
        this.$message.error('请输入短信内容！')
        return
      }
      this.$axios
        .post('/api/admin/message/send_message', {
          message: this.sendMsgForm.msg_content,
          phone: this.sendToClientPhone
        })
        .then(res => {
          let { data } = res
          if (data.code === 0) {
            this.$message.success('发送成功！')
          } else {
            this.$message.error('发送失败！')
          }
        })
    },
    handleAddWorkOrderClose(done) {
      this.$refs['sendMsgForm'].resetFields()
      done()
    },
    chooseTabEvent (tab) {
      if (tab.index === '1') {
        this.getPhoneMessages()
      }
    },
    getPhoneMessages () {
      this.$axios
        .post('/api/admin/message_records?page=' + this.pageOption4.currentPage, {
          phone: this.callPhone1
        })
        .then(res => {
          let { data } = res
          if (data.code === 0) {
            this.messageRecord = data.data.data
            this.pageOption4.total = data.data.total
          }
        })
    },
    handleSend (row) {
      this.$axios
        .post('/api/admin/message_resend', {
          id: row.id
        })
        .then(res => {
          let { data } = res
          if (data.code === 0) {
            this.getPhoneMessages()
            this.$message.success(data.msg)
          } else {
            this.getPhoneMessages()
            this.$message.error(data.msg)
          }
        })
    },
    getPhoneAddress () {
      if (this.callPhone1.length === 0) return false
      this.$axios
        .get('api/public_thread/get_customer_province', {
          params: {
            customerPhone: this.callPhone1
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.phoneFromData = data.data
          } else {
            this.$message.warning(data.msg)
          }
        })
        .catch()
    },
    hasPhone(data) {
      var arr = []
      data.map(item => {
        if (Object.hasOwnProperty.call(item,'custom_phone')) arr.push(item.custom_phone)
      })
      return arr.length
    },
    getLogs () {
      this.$axios
        .post('/api/admin/call_logs?page=' + this.pageOption.currentPage, {
          phones: this.callPhone
        })
        .then(res => {
          let { data } = res
          if (data.code === 200) {
            this.pageData = data.data.records.data
            this.pageOption.total = data.data.records.total
          }
        })
    },
    getLogs1 () {
      this.$axios
        .post('/api/admin/call_logs?page=' + this.pageOption1.currentPage, {
          phones: this.callPhone1
        })
        .then(res => {
          let { data } = res
          if (data.code === 200) {
            this.pageData1 = data.data.records.data
            this.pageOption1.total = data.data.records.total
          } else {
            this.$message.warning(data.msg)
          }
        })
    },
    getLogs2 () {
      this.$axios
        .post('/api/admin/call_logs?page=' + this.pageOption2.currentPage, {
          phones: this.callPhone2
        })
        .then(res => {
          let { data } = res
          if (data.code === 200) {
            this.pageData2 = data.data.records.data
            this.pageOption2.total = data.data.records.total
          }
        })
    },
    getLogs3 () {
      this.$axios
        .post('/api/admin/call_logs?page=' + this.pageOption3.currentPage, {
          phones: this.callPhone3
        })
        .then(res => {
          let { data } = res
          if (data.code === 200) {
            this.pageData3 = data.data.records.data
            this.pageOption3.total = data.data.records.total
          }
        })
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getLogs()
    },
    handleCurrentChange1 (val) {
      this.pageOption1.currentPage = val
      this.getLogs1()
    },
    handleCurrentChange2 (val) {
      this.pageOption2.currentPage = val
      this.getLogs2()
    },
    handleCurrentChange3 (val) {
      this.pageOption3.currentPage = val
      this.getLogs3()
    },
    handleCurrentChange4 (val) {
      this.pageOption4.currentPage = val
      this.getPhoneMessages()
    },
    play (isStorage, url) {
      if (!url) {
        this.$message.error('录音为空')
        return
      }

      if (!isStorage) {
        window.open(url)
        return
      }

      this.$axios
        .post('/api/admin/callLogs/getObject', { filePath: url })
        .then(res => {
          let { data } = res
          if (data.code === 0) {
            this.dialogPlayVisible = true
            this.waveSurferInit(data.data)
          }
        })
    },
    waveSurferInit (src) {
      this.$nextTick(() => {
        this.wavesurfer = WaveSurfer.create({
          container: this.$refs.waveform,
          barWidth: 1,
          cursorColor: 'black',
          progressColor: 'blue',
          backend: 'MediaElement',
          audioRate: '1',
          plugins: [
            Timeline.create({
              container: '#wave-timeline'
            })
          ]
        })
        this.wavesurfer.load(src)
        let that = this
        this.wavesurfer.on('finish', function () {
          that.isPlay = false
        })
      })
    },
    playMusic () {
      this.wavesurfer.playPause.bind(this.wavesurfer)()
      this.isPlay = this.wavesurfer.isPlaying()
    },
    dialogPlayVisibleBeforeClose (done) {
      this.isPlay = false
      this.wavesurfer.destroy()
      done()
    },
    call (num) {
      if (!num) {
        this.$message.error('手机号为空')
        return
      }

      // this.$axios.post('/api/admin/call_logs/' + num).then(res => {
      //   let { data } = res
      //   if (data.code === 0) {
      //     this.$message.success('调用成功，请注意接听来电')
      //   } else {
      //     this.$message.error(data.msg)
      //   }
      // })
      this.$axios.post('/api/admin/call_logs_new',{
        num
      }).then(res => {
        let { data } = res
        if (data.code === 0) {
          this.$message.success('调用成功，请注意接听来电')
        } else {
          this.$message.error(data.msg)
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .callLogs {
    .hide-style {
      display: inherit;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .mt-10 {
      margin-top: 0.2rem;
    }

    .text-r {
      text-align: right;
    }

    .callNum {
      cursor: pointer;
    }
    .ml10 {
      margin-left:0.2rem;
    }.
    .p-font{
      font-size: medium;
    }
  }
</style>



// WEBPACK FOOTER //
// src/common/MakePhone.vue